// extracted by mini-css-extract-plugin
module.exports = {"featuredSection":"Featured_featuredSection__3AnbO","featuredCards":"Featured_featuredCards__Sg7bY"};